module.exports = __webpack_public_path__ + "Simple-Line-Icons.dacd16c9a3d2cb61b472.eot";


//////////////////
// WEBPACK FOOTER
// /Users/igor/Projects/onechat/admin-dashboard/src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.eot
// module id = ../../../../../src/assets/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.eot
// module chunks = styles